// extracted by mini-css-extract-plugin
export var completionBody = "_d1-2";
export var completionCard = "_d1-0";
export var completionFooter = "_d1-3";
export var completionTitle = "_d1-1";